/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * Strict, scope–aware permission check.
 * When a scope is passed → only a rule that contains   { name: scope }   may satisfy the check
 * When no scope is passed → only a rule **without conditions** may satisfy the check
 *
 * @param ability  CASL ability instance (PureAbility)
 * @param action   e.g. 'create' or 'read'
 * @param subject  e.g. 'Restaurant_Group' or 'Reports'
 * @param scope    optional scope string, e.g. 'MML'
 */
export function strictCanScope(ability, action, subject, scope) {
  // Grab every rule that matches action + subject
  const rules = ability.rulesFor(action, subject);

  if (scope) {
    // Accept only rules whose conditions match the given scope
    return (
      rules.some((rule) => !rule.conditions) ||
      rules.some((rule) => rule.conditions && rule.conditions.name === scope)
    );
  }

  // No scope accept only rules that have NO conditions
  return rules.some((rule) => !rule.conditions);
}
